import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  Grid,
  Icon,
  Label,
  Message,
  Modal,
  Segment,
} from 'semantic-ui-react';

import { withTranslation } from 'react-i18next';
import { required, numericRange } from '@mhub/web-validations';
import { flashErrorMessage } from '../../actions/flash';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class MultiUnitAllocate extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onDeselectUnit: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    businessUnit: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })).isRequired,
    selectedRowsData: PropTypes.oneOfType([
      PropTypes.array.isRequired,
    ]).isRequired,
    allowEditUnitDetails: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    // Selected units whose agency cannot change (Vietnam: Reserved, Booked or Sold). They are
    // listed in a warning and left out of selectedRowsData so nothing is applied to them.
    lockedRowsData: PropTypes.arrayOf(PropTypes.shape({
      rowID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      reference: PropTypes.string,
    })),
  }
  static defaultProps = {
    lockedRowsData: [],
  }
  constructor(props) {
    super(props);
    const errors = {
      size: '',
      spaAmount: '',
      position: '',
      allocate: '',
    };
    this.state = {
      errors,
      fieldValue: [],
      messageText: '',
      selectedEditField: '',
      showMessage: false,
      vErrMessages: [],
      clearAll: false,
    };
    this.validation = {};
  }
  checkConfirmIsDisabled = () => {
    const { errors, fieldValue } = this.state;
    if (errors.allocate !== '') {
      return true;
    }
    if (this.props.selectedRowsData.length === 0) {
      return true;
    }
    if (!fieldValue) {
      return true;
    }
    return false;
  }
  handleDismissMessage = () => {
    this.setState({ showMessage: false });
  }
  handleInputChange = (e, data) => {
    let value = data.value;
    let clear = false;
    if (data.value.some(v => v === null)) {
      // clear all allocations
      value = [];
      clear = true;
    }
    this.setState({
      fieldValue: value,
      selectedEditField: data.name,
      clearAll: clear,
    });
  }
  handleOnClose = (e) => {
    e.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setState({
      selectedEditField: '',
      fieldValue: [],
      messageText: '',
      showMessage: false,
      clearAll: false,
    });
  }
  handleOnDeselectUnit = (e, rowID) => {
    e.preventDefault();
    const { selectedRowsData } = this.props;
    const row = selectedRowsData.find(r => r.rowID === rowID);
    const messageText = this.props.t('Successfully deselected unit {{reference}}', {
      reference: row.reference, ns: TRANSLATION_FILES.translation,
    });
    if (this.props.onDeselectUnit) {
      this.props.onDeselectUnit(e, rowID);
    }
    this.setState({ messageText, showMessage: true });
  }
  handleOnSave = async (e, closeModal) => {
    const { store } = this.context;
    e.preventDefault();
    const { selectedEditField, fieldValue, vErrMessages } = this.state;
    if (vErrMessages.length > 0) {
      await store.dispatch(flashErrorMessage({
        header: this.props.t('Please fix form errors', { ns: TRANSLATION_FILES.translation }),
        list: vErrMessages.map(l => l.message),
      }));
      return;
    }
    let showMessage = false;
    let messageText = '';
    if (this.props.onSave) {
      this.props.onSave(closeModal, selectedEditField, fieldValue);
    }
    if (!closeModal && selectedEditField !== '' && fieldValue !== '') {
      messageText = this.props.t('Successfully allocate agency for selected units', { ns: TRANSLATION_FILES.translation });
      showMessage = true;
    }
    if (closeModal) {
      this.setState({ clearAll: false });
    }
    this.setState({
      fieldValue: '',
      selectedEditField: '',
      messageText,
      showMessage,
    });
  }
  handleDataChange = (data, vErrMessages = '') => {
    this.setState({ fieldValue: data, vErrMessages });
  }
  handleOnError = (hasError, errorMessage, inputName) => {
    const { errors } = this.state;
    errors[inputName] = errorMessage;
    if (hasError) {
      errors[inputName] = errorMessage;
    } else {
      errors[inputName] = '';
    }
    this.setState({ errors });
  }
  render() {
    const {
      messageText,
      showMessage,
      clearAll,
    } = this.state;
    const { selectedRowsData, lockedRowsData, businessUnit, t } = this.props;
    const tr = key => t(key, { ns: TRANSLATION_FILES.translation });
    const clearAllOption = [{ text: tr('Clear All Allocations'), value: null }];
    const agencyOptions = clearAllOption.concat(businessUnit);
    return (
      <Modal
        closeIcon
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onClose={this.handleOnClose}
        open={this.props.open === true}
        size="tiny"
      >
        <Modal.Header style={{ textAlign: 'center' }}>{tr('Allocate')}</Modal.Header>
        <Modal.Content style={{ padding: '2em 8em' }}>
          <Grid>
            <Grid.Row >
              <Grid.Column verticalAlign="middle">
                <b>{tr('Choose agency to allocate:')}</b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Dropdown
                  onChange={this.handleInputChange}
                  name="companyBranchAllocationIDs"
                  placeholder={tr('Select agency')}
                  fluid
                  multiple
                  search
                  selection
                  selectOnBlur={false}
                  options={clearAll ? clearAllOption : agencyOptions}
                />
              </Grid.Column>
            </Grid.Row>
            {
              showMessage ?
                <Grid.Row style={{ padding: '0.5em 0' }}>
                  <Grid.Column>
                    <Message
                      onDismiss={this.handleDismissMessage}
                      success
                      size="tiny"
                      style={{ margin: '0' }}
                    >
                      <b>{messageText}</b>
                    </Message>
                  </Grid.Column>
                </Grid.Row>
            : ''
          }
            {
              lockedRowsData.length > 0 &&
                <Grid.Row style={{ padding: '0.5em 0' }}>
                  <Grid.Column>
                    <Message warning size="tiny" style={{ margin: '0' }}>
                      {selectedRowsData.length === 0
                        ? tr('None of the selected units can be allocated:')
                        : tr('The agency will not change for these units:')}
                      {' '}<b>{lockedRowsData.map(data => data.reference).join(', ')}</b>
                      {' '}{tr('(Reserved, Booked or Sold units keep their agency).')}
                    </Message>
                  </Grid.Column>
                </Grid.Row>
            }
            <Grid.Row >
              <Grid.Column>
                <Segment color="teal">
                  <div>
                    <Label.Group color="teal" size="mini">
                      {
                        selectedRowsData.length > 0 ?
                        selectedRowsData.map((data, idx) => (
                          <Label
                            as={selectedRowsData.length > 1 ? 'a' : 'div'}
                            key={idx}
                            onClick={e =>
                              selectedRowsData.length > 1 &&
                              this.handleOnDeselectUnit(e, data.rowID)
                            }
                            title={selectedRowsData.length > 1 ? tr('Deselect unit') : ''}
                          >
                            {data.reference} {
                              selectedRowsData.length > 1 ? <Icon name="remove" style={{ marginRight: '0' }} /> : ''
                            }
                          </Label>
                        ))
                        : null
                      }
                    </Label.Group>
                  </div>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions style={{ textAlign: 'center' }}>
          <Button disabled={this.checkConfirmIsDisabled()} onClick={e => this.handleOnSave(e, true)} content={tr('Apply & Close')} primary />
          <Button disabled={this.checkConfirmIsDisabled()} onClick={e => this.handleOnSave(e, false)} content={tr('Apply')} />
          <Button onClick={this.handleOnClose} content={tr('Close')} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(MultiUnitAllocate);



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitAllocate.jsx